<template>
 <div>
   <!-- <van-search v-model="phoneNumberCode" v-on:blur="search()" shape="round" background="#f5f5f5" placeholder="请输入查询手机号码"/> -->

   <div class="search-list-view">
     <van-list
       v-model="loading"
       :finished="finished"
       finished-text="没有更多了"
       @load="onLoad"
       :offset="offset"
     >
       <div v-for="item in list" :key="item" :title="item" class="search-list">
         <div>
           <svg class="icon icon_huafeiliuliangchongzhi" aria-hidden="true">
             <use xlink:href="#icon-xianjin_huaban1"></use>
           </svg>
         </div>
         <div>
           <p>{{item.phoneNumber.replace(/(\d{3})\d*(\d{4})/,'$1****$2')}}</p>
           <span>{{item.remark.length>5?item.remark.substring(0,4)+'..':item.remark}} {{item.orderAmt}}元</span>
         </div>
         <div>
           <p v-if="item.orderState=='00000'">成功</p>
           <p v-if="item.orderState=='00001'" style="color: #6e6e6e;">已下单</p>
           <p v-if="item.orderState=='00002'">支付成功</p>
           <p v-if="item.orderState=='00003'" style="color: #6e6e6e;">支付失败</p>
           <p v-if="item.orderState=='00004'" style="color: #6e6e6e;">充值中</p>
           <p v-if="item.orderState=='00005'" style="color: red;">充值失败</p>
           <p v-if="item.orderState=='00006'" style="color: red;">已退款</p>
           <span>{{item.addTime}}</span>
         </div>
       </div>
     </van-list>
   </div>
 </div>
</template>

<script>
export default {
   data() {
    return {
      list: [],
      loading: false,
      finished: false,
      phoneNumberCode:"",
      page:1,
      limit:15,
      offset:"-10"
    };
  },
  beforeCreate () {
    document.querySelector('body').setAttribute('style', 'background:#f5f5f5')
  },
  beforeDestroy () {
    document.querySelector('body').removeAttribute('style')
  },
  methods:{
    // search(){
    //   this.list = [];
    //   this.loading = false;
    //   this.finished = false;
    //   this.page = 1;
    //   this.onLoad();
    // },
    onLoad() {
          if(this.loading){
            return;
          }  
          this.loading = true;

            console.log("第几次加载",this.page);
            this.axios.post('/app/query/teamOrder', {
              page:this.page,
              limit:this.limit,
              phoneNumberCode:this.phoneNumberCode
            }).then((response) => {
              this.list = [...this.list,...response.list];
              console.log(response);
              this.loading = false;
              if(response.list.length<response.pageSize){
                this.finished = true;
              }
              this.page = this.page+1;
            }).catch((error) => {
                console.log(error);
                this.loading = false;
            });
      }
  }
};
</script>

<style scoped>
.img-icon {
  height: 20px;
}
.search-list-view{
  min-height: 85vh;
  background: #ffffff;
  margin: 10px;
  border-radius: 20px;
  padding: 15px;
  height: 100%;
}
.search-list-view .search-list{
  display: flex;
  margin: 20px 0;
}
.search-list-view .search-list div{
  vertical-align: middle;
}
.search-list-view .search-list div p{
  vertical-align: middle;
  margin: 3px 0;
}
.search-list-view .search-list div:nth-child(2){
  margin-left: 15px;
}
.search-list-view .search-list div:nth-child(2) span,.search-list-view .search-list div:nth-child(3) span{
  font-size: 13px;
  color: #cecece;
}
.search-list-view .search-list div:nth-child(3){
  position: absolute;
  right: 20px;
}
.search-list-view .search-list div:nth-child(3) p{
  color: #2BD67E;
  text-align: right;
}
</style>
